import { AfterViewInit, ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { ClearKpiConfigurationState, SaveEditKPIConfiguration, GetKpiList, RemoveSelectedKPI, ResetCreateConfigStatus, SetConfiguredKpiList, SetKPIMode, SetSelectedKPIs, SubmitKPIConfiguration, UpdateKPIActionIn } from 'src/app/core/store/kpi-configuration/kpi-configuration.action';
import { MatTableDataSource } from '@angular/material/table';
import { ActionIn, SelectedKpi } from 'src/app/core/models/insight-configuration.model';
import { KpiSelectionPopupComponent } from './kpi-selection-popup/kpi-selection-popup.component';
import { MatPaginator } from '@angular/material/paginator';
import { KpiSelectionValidationPopupComponent } from './kpi-selection-validation-popup/kpi-selection-validation-popup.component';
import { SnackbarService } from 'src/app/shared/components/snackbar/snackbar.service';
import { SnackbarType } from 'src/app/shared/components/snackbar/snackbar.enum';
import { CONFIG_MODE, IaConfigStatusBody, IaConfigStatusHeader } from 'src/app/core/enums/insightConfigurations.enum';
import { IaConfigEditStatusBody, KPI_ERROR, MAIN_TITLE, NAVIGATION_LABEL, NOTE } from 'src/app/core/enums/kpiConfiguration.enum';
import _ from 'lodash';

@Component({
  selector: 'app-kpi-insights-config',
  templateUrl: './kpi-insights-config.component.html',
  styleUrls: ['./kpi-insights-config.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class KpiInsightsConfigComponent implements OnInit, OnDestroy, AfterViewInit {

  public selectKpiModalRef: BsModalRef;
  public valdationErrorModalRef: BsModalRef;
  public selectedKPIs: SelectedKpi[] = [];
  public selectedConfigType: any;
  public unsubscribe  = new Subject<void>();
  public dataSource = new MatTableDataSource();
  public selectedKpis : SelectedKpi[];
  public configuredKpis: SelectedKpi[] = [];
  public count = 0;
  public configuredCount = 0;
  public displayedColumns: string[] = ['name', 'role', 'department', 'ahLevel', 'frequency', 'actionIn', 'buttons'];
  public selectedOption : ActionIn = {value: 1, unit: 'Day'};
  public actionInOptions: ActionIn[] = [{value: 1, unit: 'Day'}, {value: 2, unit: 'Day'},{value: 3, unit: 'Day'},{value: 4, unit: 'Day'},{value: 5, unit: 'Day'},{value: 6, unit: 'Day'},
                                        {value: 1, unit: 'Week'},{value: 2, unit: 'Week'},{value: 3, unit: 'Week'},
                                        {value: 1, unit: 'Month'}];
  public loading = false;
  public mode: number;
  public navigationLabel: string = '';
  public mainTitle: string = '';
  public note: string = '';
  public submitButtonLabel: string = '';
  public editConfiguration: any = {};
  public disabled: boolean = true;
  public actionIn: any;
  public configuredKPI: SelectedKpi;
  public kpiConfiguration: any;
  public configId: string;
  public savedActionIn: any;

  constructor(
    public router: Router,
    public modalService: BsModalService,
    public store: Store,
    private changeDetectorRef: ChangeDetectorRef,
    private snackbarService: SnackbarService
  ) {}

  @ViewChild('scheduledOrdersPaginator', {static: true}) paginator :MatPaginator;

  ngOnInit(): void {
    // Get the mode to display
    this.mode = this.store.selectSnapshot(state => state.configurations.kpi.mode);

    this.labels();
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.store.dispatch(new ClearKpiConfigurationState());
    this.store.dispatch(new GetKpiList());

    if(this.mode === CONFIG_MODE.CREATE) {
      // Show create KPI configuration screen
      this.getConfigType();
      this.getSelectedKPIs();
    }
    else if(this.mode === CONFIG_MODE.EDIT) {
      // Show edit KPI configuration screen
      this.getEditConfiguration();
      this.changeDetectorRef.detectChanges();
    }else{
      this.router.navigateByUrl('/home')
    }
  }

  ngOnDestroy() {
    this.unsubscribe.next();
    this.unsubscribe.complete();
  }

  public navigateToLanding(): void {
    this.store.dispatch(new SetKPIMode(null))
    this.router.navigateByUrl('/home')
  }

  public getSelectedKPIs() {
    this.store.select(state => state.configurations.kpi.kpisSelected).pipe(takeUntil(this.unsubscribe))
    .subscribe(selectedKPIs => {
      this.selectedKPIs = selectedKPIs;
      this.count = this.selectedKPIs.length;

      const convertSelectedKpis = this.selectedKPIs.map(kpi => {
        if(!(kpi.insightCategoryParameters)) {
          kpi.actionIn = {
            value: kpi.actionIn?.value,
            unit: kpi.actionIn?.unit
          };
          kpi.insightCategoryParameters = {
            assetHierarchyLevel: kpi.assetHierarchyLevel,
            configId: kpi.configId,
            name: kpi.name,
            uid: kpi.uid,
            frequency: kpi.frequency,
            configured: kpi.configured,
          };
          kpi.type = kpi.type;
          kpi.role = {
            roleId: kpi.role?.roleId,
            roleName: kpi.role?.roleName
          };
          kpi.department = {
            departmentId: kpi.department?.departmentId,
            departmentName: kpi.department?.departmentName
          };
          kpi.plant = {
            plantId: kpi.plant?.plantId,
            plantName: kpi.plant?.plantName
          };

        }
        return kpi;
      });
      if(this.selectedKPIs.length > 0){
        this.configuredKpis = this.selectedKPIs.filter((kpi) => kpi.configured === true || kpi?.insightCategoryParameters?.configured === true);
        this.configuredCount = this.configuredKpis.length;
        this.disabled = false;
      }
      if(!_.isEqual(this.selectedKPIs, this.dataSource.data)) {
        let selectedKpisClone =  _.cloneDeep(convertSelectedKpis);
        this.dataSource.data = selectedKpisClone.map(kpi => {
         return kpi;
        });
      }
      this.changeDetectorRef.detectChanges();
    })
  }

  public getConfigType() {
    this.store.select(state => state.configurations.selectedConfigType).subscribe(ConfigType => {
      this.selectedConfigType = ConfigType;
      this.labels();
      if(this.selectedConfigType === null) {
        this.navigateToLanding();
      }
    })
  }

  public labels(){
    // Labels according to the mode
    switch(this.mode){
      case CONFIG_MODE.CREATE:
        this.navigationLabel = 'Configure ' + this.selectedConfigType?.category;
        this.mainTitle = 'Configure ' + this.selectedConfigType?.category;
        this.note = NOTE.CREATE;
        break;
      case CONFIG_MODE.EDIT:
        this.navigationLabel = NAVIGATION_LABEL.EDIT;
        this.mainTitle = MAIN_TITLE.EDIT;
        this.note = NOTE.EDIT;
        break;
    }
  }

  public onSelectKpiClicked() {
    this.selectKpiModalRef = this.modalService.show(KpiSelectionPopupComponent, {
      class: 'modal-lg kpi-selection-modal',
      ignoreBackdropClick: true
    })
  }

  public deleteSelectedKpi(kpi: any) {
    this.store.dispatch(new RemoveSelectedKPI(kpi.insightCategoryParameters));
  }

  public updateSelectedKpi(kpi: any) {
    this.store.dispatch(new UpdateKPIActionIn(kpi));
  }

  public submitSelectedKpis(selectedKPIs: any[], selectedConfigType: any) {
    this.disabled = true;
    const newSelectedKPIs = _.cloneDeep(selectedKPIs);
    
    this.store.dispatch(new SubmitKPIConfiguration(selectedConfigType, newSelectedKPIs)).pipe(takeUntil(this.unsubscribe)).subscribe((state) => {
      this.loading = false;
      this.disabled = false;
      // Handle create config success or error scenarios
      const createConfigSuccess = state.configurations.kpi.createConfigSuccess;
      const createConfigError = state.configurations.kpi.createConfigError;

      if(createConfigSuccess === true) {
        // Show snackbar for create success
        this.snackbarService.show(SnackbarType.SUCCESS, IaConfigStatusHeader.SUCCESS, IaConfigStatusBody.SUCCESS);
        this.navigateToLanding();
      } else if(createConfigError === null) {
          // If there's no specific error message show generic snackbar for failure
          this.snackbarService.show(SnackbarType.FAILED, IaConfigStatusHeader.FAILED, IaConfigStatusBody.FAILED);
          this.navigateToLanding();
        } else {
          // Handle error scenario
          this.evaluateCreateConfigError(createConfigError);
        }
    })
  }

  public evaluateCreateConfigError(configError: any) {
    if(configError.error.errorCode == KPI_ERROR.Configuration_Exists) {
      // Show the issue modal
      this.selectedKpisValidationError();

      // Store the configured KPI list
      this.store.dispatch(new SetConfiguredKpiList(configError.error.details.configuredKPIs));
      // Reload the KPI list in the background
      this.store.dispatch(new GetKpiList()).pipe(takeUntil(this.unsubscribe)).subscribe(() => {
        this.store.dispatch(new SetSelectedKPIs(this.selectedKPIs));
        // Store the configured KPI list again
        this.store.dispatch(new SetConfiguredKpiList(configError.error.details.configuredKPIs));

        this.selectedKPIs.filter(kpi => configError.error.details.configuredKPIs.some(configuredKpi => kpi.insightCategoryParameters.uid === configuredKpi.uid)).forEach((kpi) => {
          kpi.insightCategoryParameters.configured = true;
          return kpi;
        })
        this.getSelectedKPIs();
        this.store.dispatch(new ResetCreateConfigStatus());
      })
    }
  }

  public selectedKpisValidationError(){
    // Modal for the error when user submits already configured KPIs
    this.valdationErrorModalRef = this.modalService.show(KpiSelectionValidationPopupComponent, {
      class: 'modal-message-lg validation-message-modal-container',
      ignoreBackdropClick: true,
    })
  }

  public deleteConfiguredKpis() {
    // Remove the duplicates or configured KPIs from the selected KPIs
    this.selectedKPIs = this.selectedKPIs.filter(function(kpi) {
      return !this.has(kpi?.insightCategoryParameters.uid);
    }, new Set(this.configuredKpis.map(kpi => kpi.insightCategoryParameters.uid)));

    // Store the new selected KPIs without the already configured KPIs
    this.store.dispatch(new SetSelectedKPIs(this.selectedKPIs));
  }

  public getEditConfiguration() {
    // Gets the configuration KPI details
    this.editConfiguration = this.store.selectSnapshot(state => state.configurations.kpi.editConfiguration);
    this.savedActionIn = this.editConfiguration.actionIn;
    this.dataSource.data = [this.editConfiguration];
    this.count = this.dataSource.data.length;
    this.actionIn = this.editConfiguration;
  }

  public editActionIn(actionInValue) {
    // checks to see if action in field is updated
    if(_.isEqual(actionInValue , this.savedActionIn)){
      this.disabled = true;
    }else{
      this.disabled = false;
    }
  }

  public saveEditKpi(configuredKPI: SelectedKpi) {
    // Gets the configuration Id
    const editConfigurationId = this.store.selectSnapshot(state => state.configurations.kpi.editConfigurationId);
    // Gets the configuration category
    const editConfigurationCategory = this.store.selectSnapshot(state => state.configurations.kpi.editConfigurationCategory);
    // Sets the configuration KPI details
    configuredKPI = this.editConfiguration;
    this.disabled = true;
    this.store.dispatch(new SaveEditKPIConfiguration(editConfigurationId, editConfigurationCategory, configuredKPI)).pipe(takeUntil(this.unsubscribe)).subscribe(
      () => {
        this.loading = false;
        this.disabled = false;
        // Show snackbar for edit success
        this.snackbarService.show(SnackbarType.SUCCESS, IaConfigStatusHeader.SUCCESS, IaConfigEditStatusBody.SUCCESS);
        this.navigateToLanding();
      },
      () => {
        this.disabled = false;
        // If there's no specific error message show generic snackbar for failure
        this.snackbarService.show(SnackbarType.FAILED, IaConfigStatusHeader.FAILED, IaConfigEditStatusBody.FAILED);
        this.navigateToLanding();
      }
    )
  }
}
